import { Outlet } from 'react-router-dom';
import { Sidebar, SidebarProvider } from '../components/sidebar';
import { Wrapper } from '../../ogp/layouts/helpers';

const BaseLayout = () => {
  return (
    <>
      <SidebarProvider>
        <Sidebar />
      </SidebarProvider>
      <Wrapper>
        <Outlet />
      </Wrapper>
    </>
  );
};

export { BaseLayout };
